// extracted by mini-css-extract-plugin
export default {"departmentsPanel":"ProjectsPanel-module__departmentsPanel__s7I-X"};